<template>
  <div>
<div class="footer" id="footer">
    <div class="footer_img"></div>
    <div class="content_box">
      <div class="home_container">
        <a-row>
          <a-col :span="6" :xl="6" :xs="24">
            <div class="last_left">
              <span class="contact_us">联系我们</span>
              <span class="last_text">
                很高兴收到你的来信 ! 我们看到邮件或来电，会很快给你回复。
              </span>
              <div>
                <button
                  class="last_button"
                  id="btn"
                  type="submit"
                  @click="submitForm()"
                ></button>
              </div>
            </div>
          </a-col>
          <a-col :span="6" :xl="6" :xs="24"> </a-col>
          <a-col :span="12" :xl="12" :xs="24" class="px-3 m">
            <a-form
              :model="formState"
              ref="formRef"
              :label-col="{ span: 0 }"
              autocomplete="off"
            >
              <div class="label_box">
                <a-form-item
                  label=""
                  name="orgName"
                  :wrapper-col="{ span: 22 }"
                  class="w-50"
                  :rules="[{ required: true, message: '请输入公司名称' }]"
                >
                  <a-input
                    v-model:value="formState.orgName"
                    placeholder="公司名称*"
                    :bordered="false"
                    type="text"
                  >
                    <template #prefix>
                      <img
                        class="mr-3"
                        src="../assets/img/Username.png"
                        alt=""
                      />
                    </template>
                  </a-input>
                </a-form-item>
                <a-form-item
                  label=""
                  name="mail"
                  :wrapper-col="{ span: 24 }"
                  :rules="[
                    {
                      pattern:
                        /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
                      message: '请输入正确的邮箱',
                    },
                  ]"
                >
                  <a-input
                    v-model:value="formState.mail"
                    placeholder="电子邮箱"
                    :bordered="false"
                    type="email"
                  >
                    <template #prefix>
                      <img class="mr-3" src="../assets/img/mail-.png" alt="" />
                    </template>
                  </a-input>
                </a-form-item>
              </div>
              <a-form-item
                label=""
                name="phone"
                :wrapper-col="{ span: 11 }"
                :rules="[
                  { required: true, message: '请输入手机号码' },
                  {
                    pattern: /^(13|14|15|16|17|18|19)\d{9}$/,
                    message: '请输入正确的手机号码',
                  },
                ]"
              >
                <a-input
                  v-model:value="formState.phone"
                  placeholder="您的手机号码*"
                  :bordered="false"
                  type="text"
                >
                  <template #prefix>
                    <img class="mr-3" src="../assets/img/Mobile.png" alt="" />
                  </template>
                </a-input>
              </a-form-item>
              <a-form-item
                label=""
                name="demand"
                :wrapper-col="{ span: 24 }"
                :rules="[{ required: true, message: '请简要描述您的需求' }]"
              >
                <a-input
                  v-model:value="formState.demand"
                  placeholder="请简要描述您的需求*"
                  :bordered="false"
                  type="text"
                >
                  <template #prefix>
                    <img class="mr-3" src="../assets/img/Pencil.png" alt="" />
                  </template>
                </a-input>
              </a-form-item>
            </a-form>
          </a-col>
        </a-row>
      </div>
    </div>
    <!-- 验证码对话框 -->
    <a-modal
      v-model:open="openCaptcha"
      title="验证码"
      centered
      @ok="handleOk"
      okText="确定"
      cancelText="取消"
    >
      <a-input
        v-model:value="validCode"
        placeholder="请输入验证码"
        class="my-3"
      >
        <template #suffix>
          <img
            ref="validCodeImg"
            :src="getValidCodeImg"
            @click="refreshValidCodeImg"
            class="cursor-pointer"
            width="100"
          />
        </template>
      </a-input>
    </a-modal>
  </div>
  <div class="footer_info" style="width: 100%;background-color: #031745;color: #fff !important;padding: 60px;box-sizing: border-box;">
          <a-row>
            <a-col :span="4" :xxl="4" :xl="4" :md="24" :lg="24" :xs="24">
              <div class="info_item justify-content-flex-start">
                <img src="../assets/img/邮件.png" alt="邮件" class="mr-2" />
                18435186402@163.com
              </div>
            </a-col>
            <a-col :span="5" :xxl="5" :xl="5" :md="24" :lg="24" :xs="24">
              <div class="info_item justify-content-center">
                <img src="../assets/img/电话.png" alt="电话" class="mr-2" />
                +86 184-3518-6402
              </div>
            </a-col>
            <a-col :span="5" :xxl="5" :xl="5" :md="24" :lg="24" :xs="24">
              <div class="info_item justify-content-center">
                <img src="../assets/img/地址.png" alt="地址" class="mr-2" />
                山西省太原市小店区龙盛街云特区
              </div>
            </a-col>
             <a-col :span="4" :xxl="4" :xl="4" :md="24" :lg="24" :xs="24">
              <div class="info_item justify-content-flex-start">
                晋ICP备20002705号-2
              </div>
            </a-col>
             <a-col :span="4" :xxl="4" :xl="4" :md="24" :lg="24" :xs="24">
              <div class="info_item justify-content-flex-start">
                公网安备 14010502051072号
              </div>
            </a-col>
          </a-row>
        </div>
  </div>
</template>
<script>
import { message } from 'ant-design-vue'
import axios from 'axios'
import { defineComponent, onMounted, ref, watch } from 'vue'
import { saveInfo } from '../api/api'

export default defineComponent({
  name: 'Footer',
  setup () {
    const formRef = ref()
    const formState = ref({
      orgName: '',
      mail: '',
      phone: '',
      demand: ''
    })
    const openCaptcha = ref(false)
    const validCode = ref('')
    const getValidCodeImg = ref('')
    const validCodeImg = ref(null)
    const submitForm = () => {
      formRef.value
        .validate()
        .then(() => {
          openCaptcha.value = true
          getCaptcha()
        })
        .catch((error) => {
          console.log('error', error)
        })
    }
    // 获取验证码图片
    const getCaptcha = async () => {
      const res = await axios.get(
        '/api/captcha',
        {
          responseType: 'blob'
        },
        {
          withCredentials: true
        }
      )
      const reader = new FileReader()
      reader.onload = () => {
        // 确保 result 不为 null 再赋值
        if (reader.result) {
          getValidCodeImg.value = reader.result
        }
      }
      reader.readAsDataURL(res.data)
    }
    const refreshValidCodeImg = () => {
      getCaptcha()
    }
    const handleOk = async () => {
      if (validCode.value) {
        const res = await axios.post(
          '/api/cooperative/partner',
          {
            ...formState.value,
            validCode: validCode.value
          },
          {
            withCredentials: true
          }
        )
        if (res && res.data.result === 'true') {
          message.success(res.data.message)
          validCode.value = ''
          formState.value = { orgName: '', mail: '', phone: '', demand: '' }
          openCaptcha.value = false
        } else {
          openCaptcha.value = true
          message.error(res.data.message)
        }
      } else {
        message.error('请输入验证码')
      }
    }
    return {
      formRef,
      formState,
      validCode,
      submitForm,
      openCaptcha,
      handleOk,
      getValidCodeImg,
      refreshValidCodeImg,
      validCodeImg
    }
  }
})
</script>
<style scoped lang="less">
.footer {
  width: 100%;
  margin: 0 auto;
  padding: 2rem;
  height: 100%;
  background: url("../assets/img/Group.png") no-repeat center;
  background-size: cover;
  .footer_img {
    height: 7rem;
    background: url("../assets/img/Mail.png") no-repeat center;
    margin-bottom: 2rem;
  }
  .last_left {
    height: 258px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: nowrap;
    margin-bottom: 20px;

    .contact_us {
      height: 34px;
      font-size: 34px;
      font-weight: 400;
      color: #ffffff;
    }
    .last_text {
      font-size: 14px;
      font-weight: 400;
      color: #8997a4;
      line-height: 24px;
      margin-bottom: 40px;
    }
    .last_button {
      width: 219px;
      height: 50px;
      line-height: 50px;
      background-image: url("../assets/img/submit_button.png");
      border-radius: 34px;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      color: #ffffff;
      cursor: pointer;
      border: none;
    }
  }
  .label_box {
    display: flex;
    justify-content: space-between;
  }
  /deep/ .ant-form-item {
    margin-bottom: 50px;
  }
  /deep/ .ant-form-item-control-input {
    border-bottom: 1px solid #969ba1;
    input::placeholder,
    textarea::placeholder {
      color: #969ba1;
    }
    input,
    textarea {
      color: #fff;
      font-size: 16px;
    }
  }
  .footer_info {
    color: #8997a4;
    .info_item {
      display: flex;
      align-items: center;
    }
  }
}
@media screen and (max-width: 2560px) and (min-width: 1921px) {
  .footer {
    .last_left {
      .contact_us {
        font-size: 2.4rem;
      }
      .last_text {
        font-size: 1.2rem;
      }
      .last_button {
        width: 300px;
        height: 68px;
        line-height: 68px;
        background-size: cover;
      }
    }
    /deep/ .ant-form-item-control-input {
      input,
      textarea {
        color: #fff;
        font-size: 1.2rem;
      }
    }
    .footer_info {
      font-size: 1.2rem;
      /deep/ .ant-row {
        .info_item {
          font-size: 1.2rem;
        }
        .ant-col {
          font-size: 1.2rem;
        }
      }
    }
  }
}
@media screen and (max-width: 1270px) and (min-width: 769px) {
  .footer {
    padding: 1rem;
    .footer_img {
      // height: 3rem;
      // background-size: cover;
    }
    .label_box {
      flex-direction: column;
      /deep/ .w-50 {
        width: 100% !important;
      }
    }
    .footer_info {
      /deep/ .ant-row {
        .info_item {
          justify-content: flex-start !important;
        }
        .ant-col {
          text-align: left;
          margin-bottom: 10px;
          margin-left: 1rem;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .footer {
    padding: 1rem;
    .footer_img {
      height: 3rem;
      background-size: cover;
    }
    .label_box {
      flex-direction: column;
      /deep/ .w-50 {
        width: 100% !important;
      }
    }
    .footer_info {
      /deep/ .ant-row {
        .info_item {
          justify-content: flex-start !important;
        }
        .ant-col {
          text-align: left;
          margin-bottom: 10px;
          margin-left: 1rem;
        }
      }
    }
  }
}
</style>
